import React from 'react';
import PropTypes from 'prop-types';
import { Dynatrace } from '@americanexpress/shared-scripts';
import DynatracePlaceholder from './DynatracePlaceholder';

let attrs;
try {
  // eslint-disable-next-line global-require
  attrs = require('../generated/dynatraceAttrs.json');
} catch (e) {
  attrs = null;
}

const DynatraceScript = ({ children }) => {
  const appId = attrs?.appId;
  const environment = attrs?.env;

  if (!appId || !environment) {
    return children;
  }

  return (
    <>
      <DynatracePlaceholder />
      <Dynatrace version="^3.0.0" appId={appId} environment={environment} />
      {children}
    </>
  );
};

DynatraceScript.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DynatraceScript;
